import {createContext} from "react"

export const CallContext = createContext()